<div class="loading" *ngIf="loader">Loading&#8230;</div>
<div class="container-fluid p-1" *ngIf="showForm">
    <form [formGroup]="infoForm">
        <h2 class="contactLabel" aria-live="assertive" id="contactInfoLabel"> {{ 'information.titleTextBox' | translate }}</h2>
        <ng-container *ngIf="UI_For===UI_GEN.BOTH || UI_For===UI_GEN.BORROWER">
            <div class="row no-gutters">
                <div class="col">
                    <h4 class="label_h4"> {{'information.applicant' | translate }}</h4>
                </div>
            </div>
            <div class="row no-gutters mb-4">
                <div class="col-lg-5 col-md-10">
                    <small class="form-text">
                        <label for="mobileNumber">{{ 'information.phone' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl" id="mobileNumber" tabindex="0" style="height:45px"
                        autocomplete="off" spellcheck="false" formControlName="mobileNumber" mask="000-000-0000"
                        aria-required="true" aria-describedby="mobileHelp mobileNumber" [ngClass]="(infoForm.get('mobileNumber').touched || submitted) 
                    && (infoForm.get('mobileNumber').errors?.invalidNumber || 
                    infoForm.get('mobileNumber').errors?.required) ? 'invalidBorder' : 'nonSelectBorder'" aria-labelledby="contactInfoLabel">
                    <div *ngIf="infoForm.get('mobileNumber').invalid 
                    && (infoForm.get('mobileNumber').dirty || touched || submitted)">
                        <small id="mobileHelp" class="form-text"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt="alert">
                            <span class="pt-1"> {{ 'information.pnerrormsg' | translate }} </span>
                        </small>
                    </div>
                </div>
                <div class="col-lg-5 ml-lg-4 col-md-10">
                    <small class="form-text">
                        <label for="emailTxt">{{ 'information.email' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl" id="emailTxt" tabindex="0" style="height:45px" autocomplete="off"
                        spellcheck="false" formControlName="eMail" aria-required="true" aria-describedby="emailHelp"
                        [ngClass]="(infoForm.get('eMail').touched || submitted) 
                                && (infoForm.get('eMail').errors?.invalidNumber || 
                                infoForm.get('eMail').errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                    <div *ngIf="infoForm.get('eMail').invalid 
                                && (infoForm.get('eMail').dirty || touched || submitted)">
                        <small id="emailHelp" class="form-text"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt="alert">
                            <span class="pt-1"> {{ 'information.emailerrormsg' | translate }} </span>
                        </small>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="UI_For===UI_GEN.BOTH || UI_For===UI_GEN.CO_BORROWER">
            <div class="row no-gutters">
                <div class="col">
                    <h4 class="label_h4"> {{'information.coApplicant' | translate }}</h4>
                </div>
            </div>
            <div class="row no-gutters mb-4">
                <div class="col-lg-5 col-md-10">
                    <small class="form-text">
                        <label for="co_mobileNumber">{{ 'information.phone' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl" id="co_mobileNumber" tabindex="0" style="height:45px"
                        autocomplete="off" spellcheck="false" formControlName="co_mobileNumber" mask="000-000-0000"
                        aria-required="true" aria-describedby="co_mobileHelp" [ngClass]="(infoForm.get('co_mobileNumber').touched || submitted) 
                            && (infoForm.get('co_mobileNumber').errors?.invalidNumber || 
                            infoForm.get('co_mobileNumber').errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                    <div *ngIf="infoForm.get('co_mobileNumber').invalid 
                            && (infoForm.get('co_mobileNumber').dirty || touched || submitted)">
                        <small id="co_mobileHelp" class="form-text"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt="alert">
                            <span class="pt-1"> {{ 'information.pnerrormsg' | translate }} </span>
                        </small>
                    </div>
                </div>
                <div class="col-lg-5 ml-lg-4 col-md-10">
                    <small class="form-text">
                        <label for="co_eMail">{{ 'information.email' | translate }}
                        </label>
                    </small>
                    <input type="text" class="wdd-fl" id="co_eMail" tabindex="0" style="height:45px" autocomplete="off"
                        spellcheck="false" formControlName="co_eMail" aria-required="true"
                        aria-describedby="co_emailHelp"
                        [ngClass]="(infoForm.get('co_eMail').touched || submitted) 
                                        && (infoForm.get('co_eMail').errors?.invalidNumber || 
                                        infoForm.get('co_eMail').errors?.required) ? 'invalidBorder' : 'nonSelectBorder'">
                    <div *ngIf="infoForm.get('co_eMail').invalid 
                                        && (infoForm.get('co_eMail').dirty || touched || submitted)">
                        <small id="co_emailHelp" class="form-text"> <img src="./assets/images/menu_icons/Alert.svg"
                                alt="alert">
                            <span class="pt-1"> {{ 'information.emailerrormsg' | translate }} </span>
                        </small>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="row no-gutters mb-4">
            <div col-4>
                <button type="button" tabindex="0" class="buttonCommon cancelBtn" (click)="onCancel()">{{
                    'buttonallpages.cancel' | translate }}</button>
                <button type="button" tabindex="0" class="buttonCommon saveNextBtn" (click)="onContinue()">{{
                    'buttonallpages.continuelable' | translate }}</button>
            </div>
        </div>
    </form>
</div>